import React from 'react';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { StatusFilter } from '@/hooks/useMentoriasAdmin';
import { CheckCircle2, XCircle, List } from 'lucide-react';

interface MentoriasStatusTabsProps {
  statusFilter: StatusFilter;
  setStatusFilter: (filter: StatusFilter) => void;
  activeCount: number;
  inactiveCount: number;
}

export const MentoriasStatusTabs: React.FC<MentoriasStatusTabsProps> = ({
  statusFilter,
  setStatusFilter,
  activeCount,
  inactiveCount
}) => {
  return (
    <Tabs value={statusFilter} onValueChange={(value) => setStatusFilter(value as StatusFilter)}>
      <TabsList className="bg-[#1E293B] border border-[#2A3749]">
        <TabsTrigger 
          value="all" 
          className="data-[state=active]:bg-[#00B6F0] data-[state=active]:text-black text-gray-400"
        >
          <List className="mr-2 h-4 w-4" />
          Todas ({activeCount + inactiveCount})
        </TabsTrigger>
        <TabsTrigger 
          value="active"
          className="data-[state=active]:bg-green-600 data-[state=active]:text-white text-gray-400"
        >
          <CheckCircle2 className="mr-2 h-4 w-4" />
          Ativas ({activeCount})
        </TabsTrigger>
        <TabsTrigger 
          value="inactive"
          className="data-[state=active]:bg-red-600 data-[state=active]:text-white text-gray-400"
        >
          <XCircle className="mr-2 h-4 w-4" />
          Inativas ({inactiveCount})
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
};

